import { EnRoles } from '@/interfaces/Roles';
import api from '@/services/api';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryClient';

export interface RoleGetMe {
    type: keyof typeof EnRoles;
}

export interface ClientGetMe {
    id: number;
    name: string;
}

export interface ShopManagerGetMe {
    id: number;
    name: string;
    can_change_tax_data: number | boolean;
    user_id: number;
    require_phone_validation_by_whatsapp?: number;
    emit_invoice: number | boolean;
    allow_customer_management_view: number | boolean;
}

export interface GetMeRes {
    id: number;
    email: string;
    is_confirmed: number | boolean;
    roles: RoleGetMe[];
    client: ClientGetMe;
    shopManager: ShopManagerGetMe;
}

export default function useGetMe() {
    const queryFn = async () => {
        const { data } = await api.get<GetMeRes>('/sessions/get-me');
        return data;
    };

    return useQuery({
        queryFn,
        queryKey: queryKeys.GET_ME,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        staleTime: Infinity,
        cacheTime: Infinity,
    });
}
